import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export const handleDocument = async (
  clientName,
  clientEmailData,
  appCode,
  expand,
  lotId
) => {
  var currentUserId = firebase.auth().currentUser.uid;
  var currentUserEmail = firebase.auth().currentUser.email;
  var currentUserType;
  var currentUserPhoneNumber;
  var currentUserName;
  var handleDocBuild;

  await firebase
    .database()
    .ref('/users/' + currentUserId)
    .once('value', (snapshot) => {
      currentUserType = snapshot.val().userType;
      currentUserPhoneNumber = snapshot.val().phoneNumber;
      currentUserName = snapshot.val().fullName;
      var detailsUser = {
        thisEmail: currentUserEmail,
        thisName: currentUserName,
        thisUserType: currentUserType,
        thisPhone: currentUserPhoneNumber,
        thisUID: currentUserId,
      };
      handleDocBuild = {
        clientEmail: clientEmailData,
        clientFName: clientName,
        userDetail: detailsUser,
        sellerFullName: currentUserName,
        sellerPhone: currentUserPhoneNumber,
        clientAppCode: appCode,
        lotId: lotId,
        expand: expand,
      };
      //   history.push({
      //     pathname: '/doc',
      //     state: {
      //       clientEmail: clientEmailData,
      //       clientFName: clientName,
      //       userDetail: detailsUser,
      //       sellerFullName: currentUserName,
      //       sellerPhone: currentUserPhoneNumber,
      //       clientAppCode: appCode,
      //       lotId: lotId,
      //       expand: expand,
      //       from: 'client',
      //     },
      //   });
    });
  return handleDocBuild;
};
